import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  loadWhisperCore: false,
  type: 'application',
  auth: 'none',
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  htmlTitle: 'Billing Portal',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename'
});